
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:flex;
  --outline-btn--link-padding:0.1em 1em;
  --outline-btn--link-weight-default:var(--fw-semibold);
  --outline-btn--link-weight-hover:var(--fw-semibold);
  --outline-btn--link-weight-focus:var(--fw-semibold);
}

.dropdown__trigger{
}

#dropdown{
  z-index:12;
}

.dropdown--open .dropdown__panel {
  position: fixed !important;
  left: 0px !important;
  right: 0px !important;
  z-index: 10 !important;
  width: 100% !important;
}

@media (min-width: 480px) {

  .dropdown--open .dropdown__panel {
    position: absolute !important;
  }

  .dropdown--open .dropdown__panel {
    width: auto !important;
  }

  .dropdown--open .dropdown__panel {
    min-width: 200px !important;
  }
}

.dropdown--open .dropdown__panel{
  background:var(--neutral-transparent);
}

.dropdown--open .dropdown__panel ul{
  margin:0;
  padding:0;
  list-style-type:none;
  margin-top:15px;
  background-color:var(--blue-responsible-lighten-5);
  border:1px solid var(--blue-responsible-lighten-3);
  border-top-width:0;
}

.dropdown--open .dropdown__panel a {
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  color:var(--outline-link-color-default);
  display:block;
  text-decoration:none !important;
  padding:var(--spacing-3) var(--spacing-2);
}

.dropdown--open .dropdown__panel a:hover,
  .dropdown--open .dropdown__panel a:focus{
    color:var(--outline-link-color-hover) !important;
    text-decoration:none !important;
    font-weight:var(--fw-semibold);
    background-color:var(--blue-responsible-lighten-4) !important;
  }

.dropdown--open .dropdown__panel a:focus{
    color:var(--outline-link-color-focus) !important;
    outline:2px solid var(--blue-responsible-lighten-2);
  }

.is-active{
  font-weight:var(--fw-semibold);
}
`;